let isWebpSupportedInstance = null;

const isWebpSupported = () => {
  if (isWebpSupportedInstance !== null) {
    return isWebpSupportedInstance;
  }

  const elem = typeof document !== 'undefined' ? document.createElement('canvas') : null;

  if (elem?.getContext?.('2d')) {
    isWebpSupportedInstance = elem.toDataURL('image/webp').startsWith('data:image/webp');
  } else {
    isWebpSupportedInstance = false;
  }

  return isWebpSupportedInstance;
};

export default isWebpSupported;
